import { render, staticRenderFns } from "./WomanDetails.vue?vue&type=template&id=26943537&scoped=true"
import script from "./WomanDetails.vue?vue&type=script&lang=js"
export * from "./WomanDetails.vue?vue&type=script&lang=js"
import style0 from "./WomanDetails.vue?vue&type=style&index=0&id=26943537&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26943537",
  null
  
)

export default component.exports